
import React from 'react'
import {connect} from "react-redux";
import {
    CELLTIPO_CADENA, CELLTIPO_COLOR,
    CELLTIPO_ENTERO, CELLTIPO_FECHA,
    CELLTIPO_FOREIGN, CELLTIPO_ICONOACCION, COLUMNVISIBLE_SIEMPRE,
} from "../../framework2/ej2/UI/TiposCeldas";
import {
    BOTONERA_ACCION_NUEVO,
    BOTONERA_ACCION_REFRESCAR,
    BOTONERA_REFRESCAR
} from "../../framework2/ej2/UI/FormularioBotonera";
import {
    COMPONENTE_TIPO_COLOR, COMPONENTE_TIPO_INPUT, loadDatosServicio,
    renderFormulario, renderGrid, showInputBusqueda
} from "../utils/FormularioUtils";
import Titulo from "../../framework2/ej2/UI/Titulo";
import {loadDatos} from "../utils/FormularioUtils";
import Tratamientotipo from "./Tratamientotipo";
import {Icon} from "@blueprintjs/core";

class Tratamientotipos extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            showGrid: true,
            cargandoDatos: false,
            elementoSeleccionado: null,
            datos: [],
            elementoShow: false,
            marcaTiempo: new Date(),

            filtroNombre: "",
        }

        this.columnas= [
            {campo: "M", titulo: "M", tipo: CELLTIPO_ICONOACCION,  ancho: 40,  visibilidad: COLUMNVISIBLE_SIEMPRE,
                icon: "edit",
                onAccion: (elemento) => {
                    console.log(elemento);
                    this.setState({elementoSeleccionado: elemento, showGrid: false })
                }
            },
            {campo:"nombre", titulo: "Nombre", tipo: CELLTIPO_CADENA, ancho:200},
        ];

        this.elementoConfig= {
            className: "Tratamientotipo",
            secciones: [
                {
                    titulo: "Datos",
                    campos: [
                        {campo: "nombre", titulo: "Nombre", tipo: COMPONENTE_TIPO_INPUT, cols: 4, obligatorio: true},
                    ]
                },
            ]
        };

    }

    componentDidMount() {
        this.loadDatos();
    }

    loadDatos= () =>{
        const {filtroNombre} = this.state;
        //loadDatos(this, "Tratamientotipo");

        let parametros= {
            nombre: filtroNombre,
        }

        //console.log("TRATAMIENTOS LOADDATOS");
        //console.log("parametos: ", parametros);
        loadDatosServicio(this, "Tratamientotipo", "getLista", parametros);
    }

    //------------------------------------------------------------------------------------------------------------------
    // ACCIONES
    //------------------------------------------------------------------------------------------------------------------

    onAccion= (accion, elemento) => {
        switch (accion){
            case BOTONERA_ACCION_NUEVO:
                this.nuevoElemento();
                break;

            case BOTONERA_ACCION_REFRESCAR:
                this.loadDatos();
                break;
            default:
                break;
        }
    }

    nuevoElemento= () => {
        const{estado, paciente} = this.props;

        let elemento= {
            color: "#ffffff",
        } ;

        console.log("Nuevo Elemento");
        this.setState({elementoSeleccionado: elemento, showGrid: false});
    }

    onFormularioAceptado= () => {
        this.setState({showGrid: true}, this.loadDatos);
    }

    render() {
        const {showGrid, datos, filtroNombre} = this.state;
        let propiedades={mostrarEliminar: false, height: 400};
        return (
            <div style={{margin: 8, padding: 4}}>
                {<Titulo titulo="Gestión de Tipos de tratamientos" soloTitulo={true} onNuevo={this.nuevoElemento}/> }
                {
                    <div class="fr_contenedor_buscador" >
                        {showInputBusqueda("nombre", "Nombre", filtroNombre,
                            (nombre) => this.setState({filtroNombre: nombre.toUpperCase()}),
                            this.loadDatos) }
                        <button className="fr_boton refrescar"onClick={this.loadDatos}><Icon icon="refresh" style={{marginRight: 6}}/>Refrescar</button>
                    </div>
                }
                {Boolean(showGrid) && renderGrid(this, "Tratamientos tipos", datos, this.onAccion, propiedades) }
                {!Boolean(showGrid) && renderFormulario(this, <Tratamientotipo/>)}
            </div>
        )
    }

}

Tratamientotipos.propTypes = {

}

const mapStateToProps = function(state) {
    return {
        auth: state.auth,
    }
}
export default connect(mapStateToProps)(Tratamientotipos);



